import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import aa21cfe3a76018f3e75330000557023bdb from "./generated-af60738d-e974-4dea-966a-41be84b15f75.json";

import ad5abdf4cc0f47735c8dfed394a0300bdb from "./generated-1475cf79-c83b-4b22-8ec1-1b8f1bd6b8d6.json";

import ac932e104ae74c7edc47d0502d2e35c37b from "./generated-57cdf96a-d29b-4fff-8aa5-9126c63c4767.json";

import a7ad907009c7db6fc0b93cfc057a3e69eb from "./generated-22ca0e92-9c44-4bf2-9276-dbe20b29b3f1.json";

import a72fccfef16069f3c5bf45c8bbfc40719b from "./generated-6facc558-2e1a-4450-af3a-2f4d61810e0e.json";

import ab81dec8692411653851940742aa40a84b from "./generated-30b91932-61dc-4726-a642-4ff9fe852614.json";

import a8445c938703ee1ed7be1619cc36302dcb from "./generated-72f941ad-1302-40b7-8615-8e5fbd7a9a5f.json";

import a11bf28fd1bbb9495ea7c3e5b39d40090b from "./generated-26b31d8b-e9c4-45e5-a0b3-8f330db264eb.json";

import a4027d6401f7fae84aeb74da8acea113db from "./generated-361e4e5d-ec97-4648-bfac-5fa6b2d8bd9c.json";

import af80e68e6712435c2bad938a351099abfb from "./generated-7e81a010-3560-45ac-a8d8-35aee214fe26.json";

import accc149c71451b2a194ca4168c52e643cb from "./generated-f3d28695-db45-4aa2-80e8-a7a458bb9d89.json";

import ac1dfefc6ad40565cc9f553fbc20b2059b from "./generated-e39c3b13-aa0d-40d3-9da7-204246f04b81.json";

import a5bdf2f6a3d29c0d01f11c6c6e930f6aeb from "./generated-6b6b4ee6-de6a-4334-9311-83c6793d15c1.json";

import a8236913ade5bee43ee3a07ec56e3d3fdb from "./generated-02343c29-f77e-4b59-9090-4618d68fa887.json";

import a5e788c3f30880ee8eab0612ec0fb7731b from "./generated-06753a44-0491-46a2-9ad7-fbb7e169716a.json";

import a1cd450807bd0ba0d43cdf37ef046efbcb from "./generated-85fa33aa-d652-4a30-bb15-c47f3f6a5114.json";

import af414f78f2baea4ded4e89f6a95990fb1b from "./generated-1964924d-f766-43d3-9ab1-4943ea5639e6.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(aa21cfe3a76018f3e75330000557023bdb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(ad5abdf4cc0f47735c8dfed394a0300bdb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(ac932e104ae74c7edc47d0502d2e35c37b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a7ad907009c7db6fc0b93cfc057a3e69eb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a72fccfef16069f3c5bf45c8bbfc40719b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(ab81dec8692411653851940742aa40a84b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a8445c938703ee1ed7be1619cc36302dcb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a11bf28fd1bbb9495ea7c3e5b39d40090b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a4027d6401f7fae84aeb74da8acea113db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(af80e68e6712435c2bad938a351099abfb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(accc149c71451b2a194ca4168c52e643cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ac1dfefc6ad40565cc9f553fbc20b2059b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a4027d6401f7fae84aeb74da8acea113db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a5bdf2f6a3d29c0d01f11c6c6e930f6aeb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a8236913ade5bee43ee3a07ec56e3d3fdb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a4027d6401f7fae84aeb74da8acea113db);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a5e788c3f30880ee8eab0612ec0fb7731b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a1cd450807bd0ba0d43cdf37ef046efbcb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(af414f78f2baea4ded4e89f6a95990fb1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a5e788c3f30880ee8eab0612ec0fb7731b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */